<template>
  <div class="ContainerMain">
    <Postagens id="PostagensId" class="centro"></Postagens>
    <section
      class="containe"
      v-if="this.tamanhoVetor == 1 || this.tamanhoVetor == 2 || this.tamanhoVetor == 0"
    >
      <router-link to="/postagens/escreva">
        <b-button id="buttonEscrevaAqui" class="buttonEscreva">
          Escreva aqui
        </b-button>
      </router-link>
    </section>
    <Footer class="footer"></Footer>
  </div>
</template>

<script>
import Postagens from '@/components/PostagensHome.vue';
import Footer from '@/components/Footer.vue';
import { GetAnonymousAproved } from '@/services/api/AnonymousContact.js';
import backUrl from '@/utils/backUrl.js';
import { seo } from '@/utils/seo.js';
export default {
  components: {
    Postagens,
    Footer,
  },
  metaInfo() {
    return seo(
      'Postagens Anônimas',
      'Postagens anônimas do Projeto Niara',
      `${this.backUrl}/download-file/logo/ProjetoNiaraLogo.png`,
      this.thisUrl,
      'website',
    );
  },
  data() {
    return {
      thisUrl: window.location.href,
      backUrl: backUrl,
      items: [],
      tamanhoVetor: 0,
      totalPages: null,
    };
  },
  mounted() {
    GetAnonymousAproved()
      .then((res) => {
        this.totalPages = res.data.totalPages;
        this.items = res.data.anonymousContacts;
        this.tamanhoVetor = Object.keys(this.items).length;
        if (this.tamanhoVetor == 1) {
          document.getElementById('PostagensId').classList.replace('centro', 'centro1');
        } else if (this.tamanhoVetor == 2) {
          document.getElementById('PostagensId').classList.replace('centro', 'centro2');
        }
      })
      .catch((err) => {
        if (err.response.data.erro == 'Instâncias não foram encontradas') {
          document.getElementById('PostagensId').classList.replace('centro', 'centro3');
        }
        console.error(err);
      });
  },
};
</script>
<style lang="scss" scoped>
.btn:hover {
  font-weight: bold;
}
</style>
<style lang="scss">
$fontTitle: 'Yeseva One', cursive;
$fontBody: 'Montserrat', sans-serif;
.ContainerMain {
  background-color: #fffaf4;
  .containe {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  #buttonEscrevaAqui.buttonEscreva.btn-secondary {
    background-color: #a33965 !important;
    margin-right: 1.5rem;
    margin-bottom: 1.5rem;
    font-family: $fontBody;
    font-size: 1.7rem;
    width: 14rem;
    height: 4rem;
    border-radius: 8px;
    z-index: 20;
  }
  .centro {
    margin-bottom: 7rem;
  }
  .centro3 {
    margin-bottom: 0rem;
  }
  .centro1 {
    margin-bottom: 4rem;
  }
  .centro2 {
    margin-bottom: 5rem;
  }
  @media (min-height: 1368px) {
    .centro2 {
      margin-bottom: 30rem;
    }
    .centro {
      margin-bottom: 15rem;
    }
    .centro1 {
      margin-bottom: 40rem;
    }
  }
  @media (min-height: 1366px) {
    .centro1 {
      margin-bottom: 40rem;
    }
  }
  @media (min-height: 881px) and (max-height: 1365px) {
    .centro1 {
      margin-bottom: 25rem;
    }
  }
  @media (max-height: 880px) {
    .centro1 {
      margin-bottom: 4rem;
    }
  }
  @media (max-width: 768px) {
    .centro2 {
      margin-bottom: 4rem;
    }
  }
  @media (max-width: 375px) {
  }
  @media (max-width: 1024px) and (min-width: 1024px) {
    .centro {
      padding-top: 3rem;
    }
  }
  @media (min-width: 426px) and (max-width: 768px) {
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      width: 8rem;
      height: 5rem;
      margin-left: 2rem;
      font-size: 1.37rem;
    }
  }
  @media (min-width: 376px) and (max-width: 425px) {
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      width: 8rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.37rem;
    }
  }
  @media (min-width: 321px) and (max-width: 375px) {
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      width: 7rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.3rem;
    }
  }
  @media (max-width: 320px) {
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      width: 6rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.2rem;
    }
  }
  @media (max-width: 280px) {
    #buttonEscrevaAqui.buttonEscreva.btn-secondary {
      width: 5.6rem;
      height: 5rem;
      margin-left: 0rem;
      font-size: 1.1rem;
    }
  }
}
</style>
